export default function (node) {
  return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
  || node.document && node // node is a Window
  || node.defaultView; // node is a Document
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/window.js
// module id = 432
// module chunks = 0